import { render, staticRenderFns } from "./RelatedProductsSection.vue?vue&type=template&id=5710bcaa&scoped=true&"
import script from "./RelatedProductsSection.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductsSection.vue?vue&type=style&index=0&id=5710bcaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5710bcaa",
  null
  
)

export default component.exports